import { render, staticRenderFns } from "./PostSearchResult.vue?vue&type=template&id=d9060a5c&scoped=true&"
import script from "./PostSearchResult.vue?vue&type=script&lang=js&"
export * from "./PostSearchResult.vue?vue&type=script&lang=js&"
import style0 from "./PostSearchResult.vue?vue&type=style&index=0&id=d9060a5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9060a5c",
  null
  
)

export default component.exports